<template>
  <div>
      <details class="card card--collapsible" open>
        <summary class="card__title card__title--bg-primary">
            <h5>{{ titulo }} # {{ index + 1 }}</h5>
        </summary>
        <div class="card__content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="form-inline">
                        <label :for="'marcarTodas' + titulo">
                            <input type="checkbox" @change="marcarTodas" :id="'marcarTodas' + titulo" v-model="marcar"><span>Marcar/Desmarcar todas</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <vue-good-table :columns="[
                    {
                        label : 'Conciliado',
                        field : 'conciliado',
                        filterable : false,
                    },
                    {
                        label: 'Fecha de consulta',
                        field: 'fecha_inicio',
                        filterable: true
                    },
                    {
                        label: 'Paciente',
                        field: 'paciente.nombre_completo',
                        filterable: true
                    },                        
                    {
                        label : 'Valor de consulta',
                        field : 'valor_consulta',
                        filterable : true,
                    },
                    {
                        label : 'Valor a cancelar',
                        field : 'valor_medico',
                        filterable : false,
                    }, 
                    {
                        label : '',
                        field : 'acciones'
                    }
                ]"
                :pagination-options="{
                        enabled: false
                    }"
                :rows="modelValue"
                :search-options="{
                    enabled: false,
                    placeholder: 'Buscar...'
                }"
                styleClass="vgt-table">
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field === 'acciones'">
                            <button type="button" @click="verTxt(props.row)" class="btn-info btn--text"><i class="fa fa-file"></i><span>Descargar chat</span></button>
                            <button type="button" @click="verZip(props.row)" class="btn-warning btn--text"><i class="fa fa-folder"></i><span>Descargar archivos</span></button>
                        </span>
                        <span v-else-if="props.column.field === 'conciliado'">
                            <label :for="'conciliada' + props.index + titulo">
                                <input v-model="modelValue[props.row.originalIndex].conciliada" type="checkbox" :id="'conciliada' + props.index + titulo"><span></span>
                            </label>
                        </span>
                        <span v-else-if="props.column.field === 'paciente.nombre_completo'">
                            <button type="button" @click="verPaciente(props.row)" class="btn-info btn--text">
                                <span>{{ props.formattedRow[props.column.field] }}</span>
                            </button>
                        </span>
                        <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
            <div class="table-responsive mt-2">
                <table>
                    <thead>
                        <tr>
                            <th>Total de consultas ({{ titulo }})</th>
                            <th>Valor total en consultas ({{ titulo }})</th>
                            <th>Valor final a cancelar ({{ titulo }})</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ totalConsultas }}
                            </td>
                            <td>
                                {{ moneyFormat(valorTotalConsultas) }}
                            </td>
                            <td>
                                {{ moneyFormat(valorFinalCancelar) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </details>
    <modal name="paciente" scrollable width="80%" height="auto">
      <k-paciente
        v-model="selectedPaciente"
        @cancelar="$modal.hide('paciente')"
      ></k-paciente>
    </modal>
  </div>
</template>

<script>
export default {
    computed : {
        totalConsultas : function () {
            let total = 0;
            for (let i = 0; i < this.modelValue.length; i++) {
                total += this.modelValue[i].conciliada?1:0;
            }
            return total;
        },
        valorTotalConsultas : function () {
            let valor = 0;
            for (let i = 0; i < this.modelValue.length; i++) {
                valor += this.modelValue[i].conciliada?parseFloat(this.modelValue[i].valor_consulta):0;
            }
            return valor;
        },
        valorFinalCancelar : function () {
            let valor = 0;
            for (let i = 0; i < this.modelValue.length; i++) {
                valor += this.modelValue[i].conciliada?parseFloat(this.modelValue[i].valor_medico):0;
            }
            return valor;
        }
    },
    props : {
        index : {
            type : Number,
            required : true
        },
        titulo : {
            type : String,
            required : true
        },
        value : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        }
    },
    methods : {
        verPaciente : function (row) {
            let that = this;
            axios.get(url + '/pacientes/' + row.paciente_id).then(function (response) {
                row = response.data;
                that.selectedPaciente = {
                    imagen : row.url_imagen,
                    celular : row.celular,
                    id: row.id,
                    nombre: row.nombre,
                    apellido: row.apellido,
                    fecha_nacimiento:
                    row.fecha_nacimiento !== null ? new Date(row.fecha_nacimiento) : "",
                    identificacion: row.identificacion,
                    direccion: row.direccion,
                    telefono: row.telefono,
                    email: row.email,
                    sexo: row.sexo,
                    hipertension_arterial: row.hipertension_arterial === 'S',
                    estado: row.estado,
                    _method: "PUT",
                    diabetes_mellitus: row.diabetes_mellitus === 'S',
                    cirrosis_hepatica: row.cirrosis_hepatica === 'S',
                    insuficiencia_renal: row.insuficiencia_renal === 'S',
                    hipotiroidismo: row.hipotiroidismo === 'S',
                    insuficiencia_cardiaca: row.insuficiencia_cardiaca === 'S',
                    otras: row.otras === 'S',
                    tratamiento: row.tratamiento,
                    alergias: row.alergias
                };
                that.$modal.show("paciente");
            }); 
        },
        verTxt : function (consulta) {
            if (consulta.url_txt !== null) {
                let link = document.createElement("a");
                let filename = consulta.url_txt.substring(consulta.url_txt.lastIndexOf('/')+1);
                link.download = filename;
                link.href = consulta.url_txt;
                link.click();
            }
            else 
                swal('La consulta no tuvo mensajes de chat, opción no disponible.', 'Aviso', 'warning');
        },
        verZip : function (consulta) {
            if (consulta.url_zip !== null)
                window.open(consulta.url_zip, '_blank');
            else 
                swal('No hay archivos por descargar.', 'Aviso', 'warning');
        },
        marcarTodas : function () {
            for (let i = 0; i < this.modelValue.length; i++) {
                this.modelValue[i].conciliada = this.marcar;
            }
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            moneyFormat : moneyFormat,
            marcar : false,
            selectedPaciente : null
        };
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/ItemCierrePago.vue